import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './views/list/list.component';
import { FileUploadComponent } from './views/upload/upload.component';
import { FilesRoutingModule } from './files-routing.module';
import { DropzoneComponent } from './components/dropzone/dropzone.component';
import { SharedModule } from '../shared/shared.module';
import { FileTypesComponent } from './components/file-types/file-types.component';
import { FileListItemComponent } from './components/file-list-item/file-list-item.component';
import { FormsModule } from '@angular/forms';
import { FileFilterComponent } from './components/file-filter/file-filter.component';
import { FoldersComponent } from './views/folders/folders.component';
import { FileSidebarComponent } from './components/file-sidebar/file-sidebar.component';
import { ReviewComponent } from './views/review/review.component';
import { HouseholdFilterComponent } from './components/household-filter/household-filter.component';
import { FoldersLeftNavComponent } from './views/folders-left-nav/folders-left-nav.component';
import { FoldersLeftLayoutComponent } from './views/folders-left-layout/folders-left-layout.component';
import { FileReviewModule } from '../file-review/file-review.module';

@NgModule({
  declarations: [
    ListComponent,
    FileUploadComponent,
    DropzoneComponent,
    FileTypesComponent,
    FileListItemComponent,
    FileFilterComponent,
    HouseholdFilterComponent,
    FoldersComponent,
    FileSidebarComponent,
    ReviewComponent,
    FoldersLeftNavComponent,
    FoldersLeftLayoutComponent,
  ],
  imports: [
    CommonModule,
    FilesRoutingModule,
    SharedModule,
    FormsModule,
    FileReviewModule,
  ],
  exports: [
    ListComponent,
    FileListItemComponent,
    FileFilterComponent,
    FileSidebarComponent,
    DropzoneComponent,
    FileTypesComponent
  ]
})

export class FilesModule { }
